export enum ApplicantType {
  COAPPLICANT = 'COAPPLICANT',
  APPLICANT = 'APPLICANT',
}
export enum IdentStatus {
  // Without COAPPLICANT
  SUCCESS = 'SUCCESS',
  // With COAPPLICANT but APPLICANT has already made the identification
  SUCCESS_APPLICANT = 'SUCCESS_APPLICANT',
  // With COAPPLICANT but COAPPLICANT has already made the identification with email
  SUCCESS_COAPPLICANT_EMAIL = 'SUCCESS_COAPPLICANT_EMAIL',
  // With COAPPLICANT but COAPPLICANT has already made the identification with Scrive link
  SUCCESS_COAPPLICANT_LINK = 'SUCCESS_COAPPLICANT_LINK',
  FAILURE = 'FAILURE',
}
